/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface DisambiguatedOrganizationExternalIdentifier
 */
export interface DisambiguatedOrganizationExternalIdentifier  {
    /**
     * 
     * @type {number}
     * @memberof DisambiguatedOrganizationExternalIdentifier
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DisambiguatedOrganizationExternalIdentifier
     */
    orgDisambiguatedId?: number;
    /**
     * 
     * @type {string}
     * @memberof DisambiguatedOrganizationExternalIdentifier
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof DisambiguatedOrganizationExternalIdentifier
     */
    identifierType?: string;
}

/**
 * Check if a given object implements the DisambiguatedOrganizationExternalIdentifier interface.
 */
export function instanceOfDisambiguatedOrganizationExternalIdentifier(value: object): value is DisambiguatedOrganizationExternalIdentifier {
    return true;
}

export function DisambiguatedOrganizationExternalIdentifierFromJSON(json: any): DisambiguatedOrganizationExternalIdentifier {
    return DisambiguatedOrganizationExternalIdentifierFromJSONTyped(json, false);
}

export function DisambiguatedOrganizationExternalIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisambiguatedOrganizationExternalIdentifier {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'orgDisambiguatedId': json['orgDisambiguatedId'] == null ? undefined : json['orgDisambiguatedId'],
                  'identifier': json['identifier'] == null ? undefined : json['identifier'],
                  'identifierType': json['identifierType'] == null ? undefined : json['identifierType'],
    };
}

export function DisambiguatedOrganizationExternalIdentifierToJSON(json: any): DisambiguatedOrganizationExternalIdentifier {
    return DisambiguatedOrganizationExternalIdentifierToJSONTyped(json, false);
}

export function DisambiguatedOrganizationExternalIdentifierToJSONTyped(value?: DisambiguatedOrganizationExternalIdentifier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'orgDisambiguatedId': value['orgDisambiguatedId'],
        'identifier': value['identifier'],
        'identifierType': value['identifierType'],
    };
}


